import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spin, Result, Button } from 'antd';
import campaignLinkRequestService from "../../../../services/campaignLinkRequestService";
import { useIsMobile } from "../../../../utils/helpers";

const CampaignRequestApprovePage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState<'success' | 'error'>('success');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const isMobile = useIsMobile(); // ✅ same pattern

    useEffect(() => {
        const approve = async () => {
            if (!id) return;

            try {
                const res = await campaignLinkRequestService.approveRequest(id);
                setStatus('success');
                setMessage(res.data.message || 'Request approved successfully');
            } catch (e: any) {
                setStatus('error');
                setMessage(e?.response?.data?.message || 'Failed to approve request');
            } finally {
                setLoading(false);
            }
        };

        approve();
    }, [id]);

    return (
        <div
            style={{
                maxWidth: 600,
                margin: '0 auto',
                padding: 16,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '70vh'
            }}
        >
            {loading ? (
                <Spin size="large" />
            ) : (
                <Result
                    status={status}
                    title={status === 'success' ? 'Request Approved' : 'Error'}
                    subTitle={message}
                    extra={[
                        <Button
                            key="backToRequests"
                            type="primary"
                            block={isMobile}
                            onClick={() => navigate('/campaign-requests')}
                        >
                            Back to requests
                        </Button>
                    ]}
                />
            )}
        </div>
    );
};

export default CampaignRequestApprovePage;